module.exports = __webpack_public_path__ + "img/20-lysfxy.484ef530.png";